import { Component, OnInit } from '@angular/core';
import { Audit, Capa, CapaStatus, Finding } from '../../audit.model';
import { BreadcrumbItem } from '../../../shared/shared.model';
import { ActivatedRoute, Router } from '@angular/router';
import { FindingService } from '../../finding.service';
import { AuditService } from '../../audit.service';
import { BehaviorSubject } from 'rxjs';
import { CapaService } from '../../capa.service';
import { SidService } from '../../sid.service';
import { Sid } from '../../sid.model';

@Component({
  selector: 'iaud-capa-add',
  templateUrl: './capa-add.component.html',
  styleUrls: ['./capa-add.component.scss']
})
export class CapaAddComponent implements OnInit {

  sidId: number = 0;
  findingId: number = 0;
  auditId: number = 0;
  finding: Finding = {};
  isFormValid: boolean = false;
  isSaving$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isSavingLater$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  backUrl: string;
  audit: Audit;

  cancelLink = [];

  capa: Capa = {
    status: 'draft', history:''
  };

  breadcrumbs: Array<BreadcrumbItem> = [];
  sid: Sid;

  constructor(
    private findingService: FindingService,
    private auditService: AuditService,
    private capaService: CapaService,
    private sidService: SidService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.findingId = +this.route.snapshot.params.findingId;
    this.auditId = +this.route.snapshot.params.auditId;
    this.sidId = +this.route.snapshot.params.sidId;

    if (this.findingId) {
      this.breadcrumbs = [
        {
          title: 'Home',
          path: '/home',
        },
        {
          title: 'All audits',
          path: '/audit',
        },
      ];
      this.capa.findingDataId = this.findingId;
      const auditB: BreadcrumbItem = {
        title: 'Audit',
        path: `/audit/${this.auditId}`,
      };
      this.breadcrumbs.push(auditB);
      this.auditService.getAudit(this.auditId)
        .subscribe(x => {
          this.audit = x;
          auditB.title = `Audit: ${x.auditTitle}`;
        });

      this.backUrl = `/audit/${this.auditId}/finding/${this.findingId}`;
      const b: BreadcrumbItem = {
        title: 'Finding',
        path: this.backUrl,
      };


      this.breadcrumbs.push(b);
      this.breadcrumbs.push({
        title: 'Add CAPA/EC',
        path: '',
      });

      this.findingService.getFinding(this.findingId)
        .subscribe(x => {
          this.finding = x;
          b.title = `Finding: ${x.findingTitle}`;
        });
      this.cancelLink = ['/audit', this.auditId, 'finding', this.findingId];
    } else {
      this.breadcrumbs = [
        {
          title: 'All SIDs',
          path: '/sid/list',
        }
      ];

      this.capa.sidId = this.sidId;
      this.sidService.get(this.sidId)
        .subscribe(x => {
          this.sid = x;
          this.backUrl = `/sid/${x.id}`;
          const b = {
            title: `SID: ${x.title}`,
            path: this.backUrl,
          };
          this.breadcrumbs.push(b);
          this.breadcrumbs.push({
            title: 'Add CAPA/EC',
            path: '',
          });
        });
      this.cancelLink = ['/sid', this.sidId];
      
    }
  }
  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }
  submitCapa(markAsReady: boolean): void {
    if (markAsReady) {
      this.capa.status = CapaStatus.READY_TO_SUBMIT;
      this.isSaving$.next(true);
    } else {
      this.capa.status = CapaStatus.DRAFT;
      this.isSavingLater$.next(true);
    }
    this.capaService.submitCapa(this.capa)
      .subscribe(() => {
        this.router.navigateByUrl(this.backUrl);
      });
  }
}
